import { render, staticRenderFns } from "./TagsInput.vue?vue&type=template&id=01ab4518&"
import script from "./TagsInput.vue?vue&type=script&lang=js&"
export * from "./TagsInput.vue?vue&type=script&lang=js&"
import style0 from "./TagsInput.vue?vue&type=style&index=0&id=01ab4518&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports